import inMemoryCacheFactory from "@/script/cache/utils"
import md5 from "@/script/md5"
import { $axios, apiList } from '@/api'

export default {
    state: () => ({
        findedUsers: []
    }),
    mutations: {
        setFindedUsers(store, payload) {
            store.findedUsers = payload
        }
    },
    getters: {
        findedUsers: (store) => store.findedUsers
    },
    actions: {
        getUsersList(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.user.getUsersList.method,
                    params: {
                        wsfunction: apiList.user.getUsersList.moodle_method,
                        query: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        checkCapability(_, payload)
        {
            const cacheName = 'user-capabilietes'
            const customCacheName = `${cacheName}-` + md5(JSON.stringify(payload))

            const cache = inMemoryCacheFactory(cacheName)
            if (cache.loading[customCacheName]) return cache.loading[customCacheName]

            const { resolved, notfound } = cache.read([customCacheName])
            if (notfound.length === 0) {
                return Promise.resolve(resolved[customCacheName])
            }

            return cache.loading[customCacheName] = new Promise((resolve, reject) => {
                $axios({
                    method: apiList.user.checkUserCapability.method,
                    params: {
                        wsfunction: apiList.user.checkUserCapability.moodle_method,
                        id: payload.id,
                        mode: payload.mode,
                        capability: payload.capability,

                    }
                })
                    .then(resp => {
                        cache.save({ [customCacheName]: resp.data })
                        resolve(resp.data)
                    }).catch(err => {
                        cache.stop(customCacheName)
                        reject(err)
                    })
            })
        },
        checkCourseAccess(_, id)
        {
            const cacheName = 'user-course-access'
            const customCacheName = `${cacheName}-${id}`

            const cache = inMemoryCacheFactory(cacheName)
            if (cache.loading[customCacheName]) return cache.loading[customCacheName]

            const { resolved, notfound } = cache.read([customCacheName])
            if (notfound.length === 0) {
                return Promise.resolve(resolved[customCacheName])
            }

            return cache.loading[customCacheName] = new Promise((resolve, reject) => {
                $axios({
                    method: apiList.user.checkCourseAccess.method,
                    params: {
                        wsfunction: apiList.user.checkCourseAccess.moodle_method,
                        id
                    }
                })
                    .then(resp => {
                        cache.save({ [customCacheName]: resp.data?.isAccess })
                        resolve(resp.data?.isAccess)
                    }).catch(err => {
                        cache.stop(customCacheName)
                        reject(err)
                    })
            })
        },
        getUsers(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.user.getUsersList2.method,
                    params: {
                        wsfunction: apiList.user.getUsersList2.moodle_method,
                        criteria: [
                            {
                                key: 'id',
                                value: payload
                            }
                        ]
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        syncYandexCalendar(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.user.syncCalendar.method,
                    params: {
                        wsfunction: apiList.user.syncCalendar.moodle_method,
                    },
                    data: {
                        access_token: payload.access_token,
                        token_type: payload.token_type,
                        expires_in: payload.expires_in,
                        time_modified: payload.time_modified,
                        time_expires: payload.time_expires
                    }
                }).then(resp => {
                    resolve(resp.data)
                }).catch(err => reject(err))
            })
        },
        triggerViewProfileEvent() {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.user.triggerViewEvent.method,
                    params: {
                        wsfunction: apiList.user.triggerViewEvent.moodle_method,
                        userid: 0,
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getRelevantUsers({commit}, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.user.getRelevantUsers.method,
                    params: {
                        wsfunction: apiList.user.getRelevantUsers.moodle_method,
                        query: payload,
                        courseid: 0,
                    }
                })
                    .then(resp => {
                        commit('setFindedUsers', resp.data)
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        updateUserProfile(_,payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.user.updateUser.method,
                    params: {
                        wsfunction: apiList.user.updateUser.moodle_method,
                        users: [
                            {
                                id: payload.id,
                                firstname: payload.firstName,
                                lastname: payload.lastName,
                                email: payload.email,
                                lang: payload.lang,
                            }
                        ]
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        updateUserLocale(_,payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.user.updateUserLocale.method,
                    params: {
                        wsfunction: apiList.user.updateUserLocale.moodle_method,
                        locale: payload.locale,
                    }
                })
                    .then(resp => {
                    resolve(resp.data)
                    }).catch(err => reject(err))
            })
        }
    }
}
